export default {
  isotipo: require('@/assets/images/logos/devias.png'),
  name: 'DEVIAS LOGISTIC'
}
